<template>
<Dialog header="Lütfen Özel Nitelik Seçin" 
v-model:visible="show_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<hr>
<Dropdown  v-model="selected_customattribute" placeholder="Özel Nitelikler" :options="customattributes" optionLabel="name" :editable="false"  class=" p-inputtext-sm mb-2" />

<template v-if="selected_customattribute">
	<template v-if="selected_customattribute.type=='select'">
		<Dropdown  v-model="selected_value" placeholder="Değer" :options="selected_customattribute.options" optionLabel="name" :editable="false"  class=" p-inputtext-sm w-full " />
	</template>

	<template v-if="selected_customattribute.type=='string'">
		   <InputText v-model="selected_value" placeholder="Değer" class="w-full p-inputtext-sm"/>
	</template>

	<template v-if="selected_customattribute.type=='number'">
		<InputText v-model="selected_value" type="number" placeholder="Değer" class="w-full p-inputtext-sm "/>
	</template>

	<template v-if="selected_customattribute.type=='boolean'">
		  <Dropdown  v-model="selected_value" placeholder="Değer" :options="booleanoptions" optionLabel="name" optionValue="code" :editable="false"  class="  p-inputtext-sm w-full " />
	</template>

	
</template>


</template>



<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="submitting"/>
</template>


</Dialog>
</template>

<script>
export default {

  name: 'SuppliersTableCustomAttributesModal',
  props:["selectedsuppliers","customattributes"],

  data () {
    return {
    	show_modal:false,
    	loading:false,
    	submitting:false,
    	selected_customattribute:null,
    	selected_value:null,
    	booleanoptions:[
        {name:"Açık",code:1},
        {name:"Kapalı",code:0},
        ],
    }
  },
  watch:{
  	selected_customattribute(newval)
  	{
  		this.selected_value = null
  	}
  },
  methods:{
  	showModal(action)
  	{
  		this.selected_customattribute = null
  		this.selected_value = null
  		this.show_modal = true
  	},
  	hideModal()
  	{
  		this.$emit("closemodal")
  		this.show_modal = false
  		this.submitting = false
      	this.selectedproject = null
      	this.selectedflow = null
  	},
  	selectCustomAttribute()
  	{
  		
  	},
  	submit()
  	{
  	  if(!this.selected_customattribute)
      {
        this.showMessage("error","Bir nitelik Seçin","")
        return false
      }

      if(!this.selected_value)
      {
      	if(this.selected_value!==0)
      	{
      		this.showMessage("error","Bir değer girin","")
        	return false
      	}
        
      }
      
      let selected_value
      if(this.selected_customattribute.type=="select")
      {
      	selected_value = this.selected_value.id
      }
      else
      {
      	selected_value = this.selected_value
      }

      console.log(selected_value)
      //return false

      this.submitting = true
  	  let formdata = new FormData()
  	  formdata.append("selectedsuppliers",JSON.stringify(this.selectedsuppliers))
  	  formdata.append("customattribute_id",this.selected_customattribute.id)
  	  formdata.append("customattribute_type",this.selected_customattribute.type)
  	  formdata.append("selected_value",selected_value)
  	  this.generalSubmission(formdata,"suppliers/update_supplier_attributes",this.afterSubmit)
  	},
  	afterSubmit(response)
  	{
  		console.log(response.data)
  		this.submitting = false
  		this.hideModal()
  	},

  }
}
</script>

<style lang="css" scoped>
</style>